export const rates = ["10", "15", "20", "25", "30"];

export const durations = [
  { value: 240, label: "allDay" },
  { value: 480, label: "halfDay" },
];

export const TYPE = "type";
export const CANCEL = "cancel";
